
export class OnlineEventSpecification {
    public id?: number;
    public name: string;
    public active: boolean;

    public static fromDto(e): OnlineEventSpecification {
        const onlineEventSpecification = new OnlineEventSpecification();
        if (!e) {
            return null;
        }

        onlineEventSpecification.id = e.id;
        onlineEventSpecification.name = e.name;
        onlineEventSpecification.active = e.active;

        return onlineEventSpecification;
    }
}
